import { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

// antd
import {
    Col,
    Form,
    Input,
    Row,
    Space,
    Avatar,
    Typography,
    DatePicker,
    Spin,
    Popover,
    message,
    Tabs,
    Tooltip,
    Image,
    Flex,
    Drawer,
    Card,
} from 'antd'
import { Icon } from '@iconify/react'

import {
    FilePdfOutlined,
    FileWordOutlined,
    FileExcelOutlined,
    FileImageOutlined,
    FileOutlined,
    DeleteOutlined,
} from '@ant-design/icons'

// components
import DeletePopUp from '../../components/deletePopUp/deletePopUp'

// slices
import { getSprint, sprintSelect, sprintsState } from '../sprints/sprints.slice'
import { projectsState } from '../projects/projects.slice'
import {
    clearTaskFileUpload,
    getSubTaskList,
    selectTaskUpdate,
    switchFormModal,
    taskById,
    taskCreate,
    taskDelete,
    taskFileError,
    taskList,
    taskUpdate,
    tasksState,
    updateComment,
} from './tasks.slice'
import { loginState } from '../login/login.slice'

// assets
import { DeleteIcon } from '../../assets/icons'

// sections
import CommentsSection from './comments.section'
import ActivitySection from './activity.section'

// sections
import SubTaskSection from './subTask.section'

// attachments
import AttachmentFileSection from './attachment.section'

// styles
import styles from './tasks.module.css'

// constants
import {
    deletePermissionCheck,
    editFieldCheck,
    viewFieldCheck,
} from '../../helpers/permissionCheck'
import { isEmpty } from '../../helpers/fieldCheck'

// constants
import { ESTIMATION_PATTERN } from '../../constants/patterns'
import { priorityType } from '../../constants/tasks.index'

import dayjs from 'dayjs'
import { convertUTCToLocal } from '../../helpers/utils'
import { PRIVATE_ROUTES } from '../../routes'

import './tasks.index.css'
import PrioritySelector from './components/prioritySelector'
import StatusSelector from './components/statusSelector'
import AssigneeSelectPopover from './components/assigneeSelector'
import TaskItemSelector from './components/taskItemSelector'
import MentionEditor from '../../components/MentionEditor/MentionEditor'
import S3FileUpload from 'react-s3/lib/ReactS3'
import AttachmentSection from './attachments.section'

const DrawerTaskForm = ({
    assigneeList,
    onCancel,
    activeTab,
    activeTabName,
    listTaskCall = () => {},
    DateRangeSet,
    isclearForm,
    setIsCleraForm,
    selectedTeamMembers,
}) => {
    const { Text } = Typography

    const { TextArea } = Input

    const { RangePicker } = DatePicker

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const params = useLocation()

    const { epics, sprints } = useSelector(sprintsState)
    const { userProfile } = useSelector(loginState)
    const { currentProjectData } = useSelector(projectsState)
    const { filterDropDown, formModal } = useSelector(tasksState)

    const [clearEditor, setClearEditor] = useState(false)
    const [filteredMembers, setFilteredMembers] = useState([])
    const [addCommentLoader, setAddCommentLoader] = useState(false)
    const [mentionData, setMentionData] = useState({
        name: 'React',
        value: '',
        mentionData: null,
        mentionDataList: [],
        comment: '',
        users: [],
    })

    const [commentChange, setCommentChange] = useState([])
    const [files, setFiles] = useState([])
    const {
        pageLimit,
        skipPage,
        selectedSubTask,
        formSubTask,
        selectedTask,
        taskStatus,
        taskFiles,
    } = useSelector(tasksState)

    const initialValues = useMemo(() => {
        return {
            title: '',
            type:
                activeTab && !selectedTask
                    ? activeTabName === 'Issues'
                        ? [
                              {
                                  label: 'Bug',
                                  value: 'Bug',
                              },
                          ]
                        : [
                              {
                                  label: 'Task',
                                  value: 'Task',
                              },
                          ]
                    : 'Task',
            epic:
                activeTab && !selectedTask
                    ? (() => {
                          const found = epics.find(
                              (data) => data?.title === 'general'
                          )
                          return found
                              ? [{ label: found.title, value: found._id }]
                              : []
                      })()
                    : [],
            status: {},
            rangePicker: [],
            sprintId: activeTab ? activeTab : [],
            estimation: 0,
            start: '',
            end: '',
            assigneeId: [],
            description: '',
            projectId: '',
        }
    }, [])
    const [form] = Form.useForm()
    const [sprintsOption, setSprintsOption] = useState([])
    const [epicsOption, setEpicsOption] = useState([])
    const [swimLanesOption, setSwimLanesOption] = useState([])
    const [taskTypeOption, setTaskTypeOption] = useState([])
    const [values, setValues] = useState(initialValues)
    const [errors, setErrors] = useState(initialValues)
    const [updatedValues, setUpdatedValues] = useState({})
    const [taskLoadingButton, setTaskLoadingButton] = useState(false)
    const [taskID, setTaskID] = useState('')
    const [deleteCheck, setDeleteCheck] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteButtonLoading, setDeleteButtonLoading] = useState(false)
    const [drawerWidth, setDrawerWidth] = useState(window.innerWidth * 0.4)
    const [activeTabComment, setActiveTabComment] = useState('comments')

    const [open, setOpen] = useState(false)
    const formValue = form.getFieldValue()

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen)
        if (newOpen === true) {
            setDeleteCheck(true)
        } else {
            setDeleteCheck(false)
        }
    }

    useEffect(() => {
        if (!formModal) {
            setValues({ ...values, type: '' })
        }
    }, [!formModal])

    useEffect(() => {
        if (isclearForm) {
            form.setFieldsValue(initialValues)
            setIsCleraForm(false)
        }
    }, [isclearForm, onCancel])

    useEffect(() => {
        if (!formModal) return

        if (values?.type === 'Bug') {
            const issueSprint = sprintsOption.find(
                (opt) => opt.label === 'Issues'
            )

            if (issueSprint) {
                form.setFieldsValue({ sprintId: issueSprint.value })

                setValues((prev) => ({
                    ...prev,
                    sprintId: issueSprint.value,
                }))

                setUpdatedValues((prev) => ({
                    ...prev,
                    sprintId: issueSprint.value,
                }))
            } else {
                form.setFieldsValue({ sprintId: null })

                setValues((prev) => ({
                    ...prev,
                    type: null,
                    sprintId: null,
                }))

                setUpdatedValues((prev) => ({
                    ...prev,
                    sprintId: null,
                }))
            }
        } else {
            if (activeTab) {
                form.setFieldsValue({ sprintId: activeTab })

                setValues((prev) => ({
                    ...prev,
                    sprintId: activeTab,
                }))

                setUpdatedValues((prev) => ({
                    ...prev,
                    sprintId: activeTab,
                }))
            } else if (selectedTask?.sprintId?.[0]?._id) {
                const taskSprintId = selectedTask.sprintId[0]._id

                form.setFieldsValue({ sprintId: taskSprintId })

                setValues((prev) => ({
                    ...prev,
                    sprintId: taskSprintId,
                    assigneeId: selectedTask?.assigneeId[0]?._id,
                }))

                setUpdatedValues((prev) => ({
                    ...prev,
                    sprintId: taskSprintId,
                }))
            } else {
                const issueSprint =
                    sprintsOption?.length > 0 &&
                    sprintsOption.find(
                        (opt) => opt?.value === filterDropDown?.sprintId
                    )
                form.setFieldsValue({ sprintId: issueSprint.value })

                setValues((prev) => ({
                    ...prev,
                    sprintId: issueSprint.value,
                    assigneeId: [],
                }))

                setUpdatedValues((prev) => ({
                    ...prev,
                    sprintId: issueSprint.value,
                }))
            }
        }
    }, [values?.type, sprintsOption, selectedTask, formModal, activeTab])

    useEffect(() => {
        const handleResize = () => setDrawerWidth(window.innerWidth * 0.36)
        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const isBugType =
        (Array.isArray(formValue.type) &&
            formValue?.type.some((t) => t.value === 'Bug')) ||
        formValue?.type === 'Bug'

    const dropDownIcon = [
        {
            title: deletePermissionCheck('tasks', userProfile) ? (
                'Delete'
            ) : (
                <Tooltip
                    arrow={false}
                    placement="bottom"
                    title="You don't have permission to delete task"
                >
                    <Text
                        style={{
                            margin: '0px',
                        }}
                    >
                        Delete
                    </Text>
                </Tooltip>
            ),
            icon: <DeleteIcon />,
            onClick: (_id) => {
                if (deletePermissionCheck('tasks', userProfile)) {
                    setDeleteCheck(true)
                    setTaskID(_id)
                    setDeleteModal(true)
                }
            },
        },
    ]

    const dropDownContent = (id) => {
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '8px',
                    }}
                >
                    {dropDownIcon?.length > 0 &&
                        dropDownIcon.map((data) => (
                            <Row
                                style={{
                                    cursor: 'pointer',
                                }}
                                align={'middle'}
                                onClick={() => data?.onClick(id)}
                            >
                                <div
                                    style={{
                                        marginRight: '10px',
                                    }}
                                >
                                    {data?.icon}
                                </div>
                                <Text className="sub-title">{data?.title}</Text>
                            </Row>
                        ))}
                </div>
            </>
        )
    }

    useEffect(() => {
        if (userProfile?.activeProject?._id) {
            setValues({
                ...values,
                projectId: userProfile?.activeProject?._id,
            })
        }
    }, [values?.type])
    const tabs = [
        {
            key: 'comments',
            label: 'Comments',
            children: (
                <CommentsSection
                    setFilteredMembers={setFilteredMembers}
                    mentionData={mentionData}
                    files={files}
                    setCommentChange={setCommentChange}
                    commentChange={commentChange}
                />
            ),
        },
        {
            key: 'activity',
            label: 'All Activity',
            children: <ActivitySection />,
        },
    ]

    const formatDatePicker = (value) => {
        return `${dayjs(value).format('DD MMM YY')}`
    }
    useEffect(() => {
        if (epics?.length > 0) {
            const options = epics.map((data) => {
                return {
                    label: data?.title,
                    value: data?._id,
                    epicKey: data?.epicKey,
                }
            })
            setEpicsOption(options)
        }
    }, [epics])

    useEffect(() => {
        if (sprints?.length > 0) {
            const options = sprints
                .filter((data) => !data?.isComplete)
                .map((data) => {
                    return {
                        label: data?.title,
                        value: data?._id,
                    }
                })
            setSprintsOption(options)
        }
    }, [sprints])

    useEffect(() => {
        if (epicsOption?.length > 0) {
            const epicFound =
                epicsOption?.length > 0 &&
                epicsOption.find((opt) => opt?.label === 'general')
            form.setFieldsValue({ epic: epicFound?.value })

            setValues((prev) => ({
                ...prev,
                epic: epicFound?.value,
            }))

            setUpdatedValues((prev) => ({
                ...prev,
                epic: epicFound?.value,
            }))
        }
    }, [epicsOption, formModal])

    useEffect(() => {
        if (currentProjectData?.swimlanes?.length > 0) {
            const options = currentProjectData?.swimlanes.map((data) => {
                return {
                    label: data?.name,
                    value: data?._id,
                }
            })
            setSwimLanesOption(options)
        }
        if (currentProjectData?.taskType?.length > 0) {
            const options = currentProjectData?.taskType.map((data) => {
                return {
                    label: data,
                    value: data,
                }
            })
            setTaskTypeOption(options)
        }
    }, [currentProjectData])

    async function subTaskListGet() {
        await dispatch(
            getSubTaskList({
                skip: 0,
                limit: 10,
                parentId: selectedTask?._id,
            })
        )
    }

    useEffect(() => {
        if (selectedTask) {
            subTaskListGet()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTask])

    useEffect(() => {
        if (selectedTask !== undefined) {
            const { _id: value, title: label } = {
                ...selectedTask?.epic[0],
            }
            const {
                _id: valueAssignee,
                name: labelAssignee,
                profilePicture,
            } = {
                ...selectedTask?.assigneeId[0],
            }
            const new_obj = Object.assign(
                {},
                {
                    label,
                    value,
                }
            )

            const new_obj_assignee = Object.assign(
                {},
                {
                    label: labelAssignee && (
                        <Space size="small">
                            {profilePicture ? (
                                <Image
                                    src={profilePicture}
                                    height={'30px'}
                                    preview={false}
                                    width={'30px'}
                                    style={{
                                        borderRadius: '50%',
                                    }}
                                />
                            ) : (
                                <Avatar
                                    style={{
                                        backgroundColor: 'rgb(0 10 129 / 25%)',
                                        cursor: 'pointer',
                                        height: '30px',
                                        width: '30px',
                                    }}
                                >
                                    {labelAssignee[0].toUpperCase()}
                                    {labelAssignee.split(' ')[1] !==
                                        undefined &&
                                    labelAssignee.split(' ')[1] !== ''
                                        ? labelAssignee
                                              .split(' ')[1][0]
                                              .toUpperCase()
                                        : ''}
                                </Avatar>
                            )}
                            <Text
                                style={{
                                    margin: 0,
                                }}
                            >
                                {labelAssignee && labelAssignee}
                            </Text>
                        </Space>
                    ),
                    value: valueAssignee,
                }
            )

            if (selectedTask) {
                const { _id: valueSprint, title: labelSprint } = {
                    ...selectedTask?.sprintId[0],
                }

                const type = [
                    {
                        label: selectedTask?.type,
                        value: selectedTask?.type,
                    },
                ]
                const swimLanes = {
                    label: selectedTask?.status,
                    value: selectedTask?.status,
                }

                const new_obj_sprint = Object.assign(
                    {},
                    {
                        label: labelSprint,
                        value: valueSprint,
                    }
                )

                form.setFieldsValue({
                    ...selectedTask,
                    type,
                    rangePicker: [
                        convertUTCToLocal(selectedTask?.start ?? ''),
                        convertUTCToLocal(selectedTask?.end ?? ''),
                    ],
                    estimation: checkEstimation(selectedTask?.estimation)
                        .trimStart()
                        .trimEnd(),
                    start: selectedTask?.start
                        ? dayjs(selectedTask?.start, 'YYYY/MM/DD')
                        : '',
                    end: selectedTask?.end
                        ? dayjs(selectedTask?.end, 'YYYY/MM/DD')
                        : '',
                    sprintId: [{ ...new_obj_sprint }],
                    epic: [{ ...new_obj }],
                    assigneeId:
                        new_obj_assignee?.label === undefined &&
                        new_obj_assignee?.value === undefined
                            ? []
                            : [{ ...new_obj_assignee }],
                    status: swimLanes,
                })
            }
            if (activeTab) {
                if (selectedTask) {
                    const swimLanes = {
                        label: selectedTask?.status,
                        value: selectedTask?.status,
                    }

                    form.setFieldsValue({
                        ...selectedTask,
                        status: swimLanes,
                        estimation:
                            checkEstimation(selectedTask?.estimation)
                                .trimStart()
                                .trimEnd() || 0,
                        epic: [{ ...new_obj }],
                        assigneeId: [{ ...new_obj_assignee }],
                        sprintId: [{ label: activeTabName, value: activeTab }],
                    })
                }
            }
        } else {
            form.resetFields()
            dispatch(clearTaskFileUpload())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, selectedTask, activeTab, params])

    // CHECK ESTIMATION
    function checkEstimation(value) {
        let estimateMinutes = `0m`
        let estimateHours = `0h`
        let estimateWeeks = `0w`
        let estimateDays = `0d`
        const defaultTime = currentProjectData?.defaultTime
        const defaultWeek = currentProjectData?.defaultWeek
        let minutes = value
        if (minutes > 60) {
            estimateMinutes = `${minutes % 60}m`
            const hours = parseInt(minutes / 60)
            if (hours >= defaultTime) {
                estimateHours = `${hours % defaultTime}h`
                const days = parseInt(hours / defaultTime)
                if (days > defaultWeek) {
                    estimateDays = `${days % defaultWeek}d`
                    estimateWeeks = `${parseInt(days / defaultWeek)}w`
                } else {
                    estimateDays = `${days}d`
                }
            } else {
                estimateHours = `${hours}h`
            }
        } else {
            estimateMinutes = `${minutes}m`
        }

        const estimationNew = `${
            estimateWeeks.split('w')[0] !== '0' ? `${estimateWeeks} ` : ''
        }${estimateDays.split('d')[0] !== '0' ? `${estimateDays} ` : ''}${
            estimateHours.split('h')[0] !== '0' ? `${estimateHours} ` : ''
        }${estimateMinutes.split('m')[0] !== '0' ? estimateMinutes : ''}`
        form.setFieldValue('estimation', estimationNew.trimStart().trimEnd())
        return estimationNew
    }

    // CHECK ESTIMATION
    function checkFinalEstimation(value) {
        let estimateMinutes = 0

        const splitValue = value.split(' ')

        const defaultTime = currentProjectData?.defaultTime
        const defaultWeek = currentProjectData?.defaultWeek

        splitValue.forEach((data) => {
            if (data.includes('w')) {
                let week = parseInt(data.split('w')[0])
                estimateMinutes += week * defaultWeek * defaultTime * 60
            }
            if (data.includes('d')) {
                let week = parseInt(data.split('d')[0])
                estimateMinutes += week * defaultTime * 60
            }
            if (data.includes('h')) {
                let week = parseInt(data.split('h')[0])
                estimateMinutes += week * 60
            }
            if (data.includes('m')) {
                let week = parseInt(data.split('m')[0])
                estimateMinutes += week
            } else if (
                !data.includes('w') &&
                !data.includes('d') &&
                !data.includes('h') &&
                !data.includes('m')
            ) {
                estimateMinutes = parseInt(data)
            }

            updateDetails('estimation', estimateMinutes)
            checkEstimation(estimateMinutes)
        })
    }

    // DELETE TASK
    async function deleteTask() {
        const result = await dispatch(taskDelete(taskID))
        const data = result?.payload?.data
        const sprintId = JSON.parse(localStorage.getItem('currentSprint'))?.id

        if (data) {
            const { success, message: checkMessage } = data
            if (success) {
                setDeleteButtonLoading(false)
                setDeleteModal(false)
                setTaskID('')
                dispatch(switchFormModal({ open: false }))
                message.success(checkMessage)

                if (activeTab) {
                    const result = await dispatch(getSprint({ id: activeTab }))
                    const data = result?.payload?.data
                    if (data) {
                        const { success } = data
                        if (success) {
                            dispatch(sprintSelect(data?.data))
                        }
                    }
                    listTaskCall(data?.data)
                } else {
                    if (DateRangeSet) {
                        DateRangeSet()
                    }

                    dispatch(
                        await taskList({
                            limit: pageLimit,
                            skip: skipPage,
                            filter: {
                                projectId: userProfile?.activeProject?._id,
                                assignee: selectedTeamMembers,
                                sprintId:
                                    localStorage.getItem('currentSprint') &&
                                    sprintId,
                            },
                        })
                    )
                }
            } else {
                setDeleteModal(false)
                setDeleteButtonLoading(false)
                setTaskID('')
                if (checkMessage) {
                    message.error(checkMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    // UPDATE DETAILS
    function updateDetails(name, value) {
        setValues({
            ...values,
            [name]: value,
        })
        setErrors({ ...errors, [name]: '' })

        if (name === 'assigneeId' || name === 'sprint' || name === 'epic') {
            const currentValue =
                Array.isArray(values?.[name]) && values[name].length > 0
                    ? values[name][0].value
                    : null

            if (currentValue !== value) {
                setUpdatedValues((prev) => ({
                    ...prev,
                    [name]: value,
                }))
            }
        } else {
            if (values?.[name] !== value) {
                setUpdatedValues((prev) => ({
                    ...prev,
                    [name]: value,
                }))
            }
        }
    }

    // ONFINISH
    const onFinish = async () => {
        try {
            let newFilterValue = {}
            const backlogId = sprintsOption
                .filter((data) => data?.label === 'Backlog')
                .map((data) => data?.value)
            if (values?.type === 'Bug') {
                const issueSprint = sprintsOption.find(
                    (opt) => opt.label === 'Issues'
                )
                if (!issueSprint) {
                    message.warning("Please create an 'Issues' sprint first.")
                    return
                }
            }
            Object.keys(values).forEach((data) => {
                if (data === 'estimation') {
                    newFilterValue = { ...newFilterValue, [data]: values[data] }
                }
                if (data === 'start' || data === 'end') {
                    if (values[data] !== '') {
                        newFilterValue = {
                            ...newFilterValue,
                            [data]: values[data],
                        }
                    } else {
                        newFilterValue = { ...newFilterValue }
                    }
                } else {
                    if (values[data] !== '' && values[data]?.length > 0) {
                        newFilterValue = {
                            ...newFilterValue,
                            [data]: values[data],
                        }
                    } else {
                        newFilterValue = {
                            ...newFilterValue,
                        }
                    }
                }
            })
            if (!newFilterValue['sprintId']) {
                newFilterValue = {
                    ...newFilterValue,
                    // sprintId: activeTab ? activeTab : backlogId[0],
                }
            }

            setTaskLoadingButton(true)
            const result = selectedTask
                ? await dispatch(
                      taskUpdate({
                          updateTask: {
                              ...updatedValues,
                              status: updatedValues?.status?.label,
                              attachment: taskFiles,
                          },
                          _id: selectedTask?._id,
                      })
                  )
                : await dispatch(
                      taskCreate({ ...newFilterValue, attachment: taskFiles })
                  )
            const data = result?.payload?.data
            if (data) {
                const { success, message: checkMessage } = data
                if (success) {
                    if (activeTab) {
                        const result = await dispatch(
                            getSprint({ id: activeTab })
                        )
                        const data = result?.payload?.data
                        if (data) {
                            const { success } = data
                            if (success) {
                                dispatch(sprintSelect(data?.data))
                            }
                        }
                        listTaskCall(data?.data)
                    } else {
                        dispatch(
                            taskList({
                                limit: pageLimit,
                                skip: skipPage,
                                filter: {
                                    assignee: selectedTeamMembers,
                                    projectId: userProfile?.activeProject?._id,

                                    sprintId:
                                        filterDropDown?.sprintId ??
                                        JSON.parse(
                                            localStorage.getItem(
                                                'currentSprint'
                                            )
                                        )?.id,
                                },
                            })
                        )
                    }

                    if (selectedTask) {
                        const result = await dispatch(
                            taskById({ _id: selectedTask?._id })
                        )
                        const data = result?.payload?.data
                        if (data) {
                            dispatch(selectTaskUpdate(data?.data[0]))
                            if (DateRangeSet) {
                                DateRangeSet()
                            }
                        } else {
                            message.error(
                                'Something went wrong, try again later.'
                            )
                        }
                    } else {
                        onCancel()
                    }
                    onCancel()
                    form.resetFields()
                    dispatch(clearTaskFileUpload())
                    setTaskLoadingButton(false)
                    message.success(checkMessage)
                } else {
                    onCancel()
                    form.resetFields()
                    setTaskLoadingButton(false)
                    if (typeof checkMessage === 'object') {
                        for (const key in checkMessage) {
                            message.error(checkMessage[key])
                        }
                    } else if (typeof checkMessage === 'string') {
                        message.error(checkMessage)
                    } else {
                        message.error('Something went wrong, try again later.')
                    }
                }
                setUpdatedValues({})
                setValues({})
                listTaskCall()
            }
        } catch (error) {
            listTaskCall()
        }
    }

    const onFinishFailed = () => {}

    const CopyTextButton = ({ text }) => {
        const handleCopy = () => {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    message.success('Link copied!')
                })
                .catch(() => {
                    message.error('Failed to copy link')
                })
        }

        return (
            <Tooltip title="Copy task link">
                <Icon
                    icon="solar:link-outline"
                    height={20}
                    width={20}
                    onClick={handleCopy}
                    style={{
                        cursor: 'pointer',
                    }}
                />
            </Tooltip>
        )
    }

    const onCloseTaskDrawer = () => {
        dispatch(switchFormModal({ open: false }))
        dispatch(clearTaskFileUpload())
        dispatch(taskFileError(''))
        if (params?.search.includes('taskId')) {
            navigate(PRIVATE_ROUTES.tasks)
        }
    }

    const [autoSaving, setAutoSaving] = useState(false)
    /** store an id for newly created tasks in this drawer session */
    const [createdTaskId, setCreatedTaskId] = useState(null)

    const ensureIssueSprintIfNeeded = () => {
        if (values?.type === 'Bug') {
            const issue = sprintsOption.find((opt) => opt.label === 'Issues')
            if (!issue) {
                message.warning("Please create an 'Issues' sprint first.")
                return null
            }
            return issue.value
        }
        return null
    }

    // ADD COMMENT
    async function addComment(files) {
        setAddCommentLoader(true)
        const result = await dispatch(
            updateComment({
                id: formSubTask ? selectedSubTask?._id : selectedTask?._id,
                data: {
                    fieldName: 'add',
                    comment: {
                        uId: userProfile?._id,
                        username: userProfile?.name,
                        createdDate: new Date().getTime(),
                        content: mentionData?.comment,
                        mentionId: mentionData?.mentionDataList,
                        attachments: files?.length > 0 ? files : [],
                    },
                },
            })
        )

        const data = result?.payload?.data
        if (data) {
            setMentionData({ ...mentionData, value: '', comment: '' })

            setFiles([])
            const { success, message: checkMessage } = data
            if (success) {
                setAddCommentLoader(false)

                const newComment = {
                    uId: userProfile?._id,
                    mentionId: mentionData?.mentionDataList,
                    attachments: files?.length > 0 ? files : [],
                    content: mentionData?.comment,
                    createdDate: new Date().getTime(),
                    user: {
                        _id: userProfile?._id,
                        name: userProfile?.name,
                    },
                    username: userProfile?.name,
                }
                setCommentChange((prev) => [newComment, ...prev])
                message.success(checkMessage)
                // const resultFinal = await dispatch(
                //     taskById({
                //         _id: formSubTask
                //             ? selectedSubTask?._id
                //             : selectedTask?._id,
                //     })
                // )
                // const dataFinal = resultFinal?.payload?.data
                // if (!formSubTask) {
                //     if (dataFinal) {
                //         dispatch(selectTaskUpdate(dataFinal?.data[0]))
                //     } else {
                //         message.error('Something went wrong, try again later.')
                //     }
                // }
            } else {
                if (checkMessage) {
                    message.error(checkMessage)
                    setAddCommentLoader(false)
                } else {
                    message.error('Something went wrong, try again later.')
                    setAddCommentLoader(false)
                }
            }
        }
    }

    // S3 UPLOAD FILE
    async function s3Upload() {
        let fileUpload = []
        let stream = true
        setAddCommentLoader(true)
        if (files?.length > 0) {
            files?.length > 0 &&
                files.forEach((data) => {
                    const nameChange = data?.name
                        .split('.')[0]
                        .concat(`_${dayjs(new Date()).unix()}`)
                        .concat(`.${data?.name.split('.')[1]}`)

                    const newFileData = new File(
                        [data?.originFileObj],
                        nameChange,
                        { type: data?.type }
                    )
                    window.Buffer = window.Buffer || require('buffer').Buffer

                    S3FileUpload.uploadFile(newFileData, userProfile?.s3Config)
                        .then(async (data) => {
                            if (files?.length === fileUpload?.length + 1) {
                                stream = false
                            }
                            fileUpload.push(data?.location)
                            if (stream === false) {
                                addComment(fileUpload)
                                setClearEditor(true)
                            }
                        })
                        .catch(() => {
                            message.error('Upload Failed!. Please Upload again')
                        })
                })
        } else {
            addComment()
            setClearEditor(true)
        }
    }

    const getFileIcon = (name) => {
        const ext = name.split('.').pop().toLowerCase()
        switch (ext) {
            case 'pdf':
                return (
                    <FilePdfOutlined
                        style={{ fontSize: 20, color: '#ff4d4f' }}
                    />
                )
            case 'doc':
            case 'docx':
                return (
                    <FileWordOutlined
                        style={{ fontSize: 20, color: '#1890ff' }}
                    />
                )
            case 'xls':
            case 'xlsx':
                return (
                    <FileExcelOutlined
                        style={{ fontSize: 20, color: '#52c41a' }}
                    />
                )
            case 'png':
            case 'jpg':
            case 'jpeg':
                return (
                    <FileImageOutlined
                        style={{ fontSize: 20, color: '#722ed1' }}
                    />
                )
            default:
                return (
                    <FileOutlined style={{ fontSize: 20, color: '#595959' }} />
                )
        }
    }

    const handleChangeMentions = (newValue, newPlainTextValue, mentions) => {
        // const mentionNew =
        //     mentions?.length > 0 ? mentions.map((data) => data?.id) : []

        setMentionData({
            ...mentionData,
            value: newValue,
            comment: newPlainTextValue,
            mentionDataList: mentions,
        })
    }

    const parseEstimationToMinutes = (value) => {
        if (!value) return undefined

        let estimateMinutes = 0
        const splitValue = value.trim().split(' ')
        const defaultTime = currentProjectData?.defaultTime
        const defaultWeek = currentProjectData?.defaultWeek

        splitValue.forEach((data) => {
            if (data.endsWith('w'))
                estimateMinutes +=
                    parseInt(data) * defaultWeek * defaultTime * 60
            else if (data.endsWith('d'))
                estimateMinutes += parseInt(data) * defaultTime * 60
            else if (data.endsWith('h')) estimateMinutes += parseInt(data) * 60
            else if (data.endsWith('m')) estimateMinutes += parseInt(data)
        })

        return estimateMinutes
    }

    const buildPayload = (allValues) => {
        // Convert estimation text to minutes (reusing your logic)

        const estimationMinutes =
            typeof allValues.estimation === 'string'
                ? parseEstimationToMinutes(allValues.estimation)
                : allValues?.estimation

        /*  let estimationMinutes = undefined
        if (allValues?.estimation) {
            checkFinalEstimation(allValues.estimation)
            // checkFinalEstimation already updates state; also include raw text for backend if required
            estimationMinutes = updatedValues?.estimation ?? undefined
        } */

        const payload = {
            title: allValues?.title,
            description: allValues?.description,
            type: Array.isArray(allValues?.type)
                ? allValues.type?.[0]?.value
                : allValues?.type,
            epic: Array.isArray(allValues?.epic)
                ? allValues.epic?.[0]?.value
                : allValues?.epic,
            sprintId: Array.isArray(allValues?.sprintId)
                ? allValues.sprintId?.[0]?.value
                : allValues?.sprintId,
            assigneeId: Array.isArray(allValues?.assigneeId)
                ? allValues.assigneeId?.[0]?.value
                : allValues?.assigneeId,
            priority: allValues?.priority,
            status: allValues?.status?.label ?? allValues?.status, // update expects label
            start: allValues?.rangePicker?.[0]?.$d
                ? new Date(allValues.rangePicker[0].$d).setHours(
                      23,
                      59,
                      59,
                      999
                  )
                : undefined,
            end: allValues?.rangePicker?.[1]?.$d
                ? new Date(allValues.rangePicker[1].$d).setHours(
                      23,
                      59,
                      59,
                      999
                  )
                : undefined,
            estimation: estimationMinutes,
            projectId: userProfile?.activeProject?._id,
            attachment: taskFiles,
        }

        // If Bug, force sprintId to Issues
        const issueSprintId = ensureIssueSprintIfNeeded()
        if (issueSprintId) payload.sprintId = issueSprintId

        // Remove empty keys to avoid backend complaints
        Object.keys(payload).forEach((k) => {
            const v = payload[k]
            const emptyArray = Array.isArray(v) && v.length === 0
            if (v === undefined || v === '' || emptyArray) delete payload[k]
        })
        return payload
    }

    const createOrUpdate = async (allValues, changedKeys = []) => {
        setAutoSaving(true)
        try {
            const isCreating = !selectedTask && !createdTaskId
            const titleTrim = (allValues?.title ?? '').trim()

            // ✅ Do not create until the user has typed a title
            if (isCreating) {
                if (!titleTrim) return
                // also require core fields before first create
                const typeVal = Array.isArray(allValues?.type)
                    ? allValues.type?.[0]?.value
                    : allValues?.type
                const epicVal = Array.isArray(allValues?.epic)
                    ? allValues.epic?.[0]?.value
                    : allValues?.epic

                // if not a Bug, require sprint for first create
                const sprintVal = Array.isArray(allValues?.sprintId)
                    ? allValues.sprintId?.[0]?.value
                    : allValues?.sprintId
                const needsSprint = typeVal !== 'Bug'

                if (!typeVal || !epicVal || (needsSprint && !sprintVal)) return
            }

            // Optional: if user tries to clear title later, block update & show error
            if (!isCreating && changedKeys.includes('title') && !titleTrim) {
                form.setFields([
                    { name: 'title', errors: ['Enter Task Title.'] },
                ])
                return
            }

            const payload = buildPayload(allValues) // same helper as before
            if (isCreating) {
                const res = await dispatch(taskCreate(payload))

                const taskData = res?.payload?.data

                if (taskData?.success && taskData?.data) {
                    setCreatedTaskId(taskData?.data)
                    dispatch(
                        taskList({
                            limit: pageLimit,
                            skip: skipPage,
                            filter: {
                                assignee: selectedTeamMembers,
                                projectId: userProfile?.activeProject?._id,

                                sprintId:
                                    filterDropDown?.sprintId ??
                                    JSON.parse(
                                        localStorage.getItem('currentSprint')
                                    )?.id,
                            },
                        })
                    )

                    const result = await dispatch(
                        taskById({ _id: taskData?.data })
                    )

                    const data = result?.payload?.data
                    if (data) {
                        dispatch(selectTaskUpdate(data?.data[0]))
                        if (DateRangeSet) {
                            DateRangeSet()
                        }
                    } else {
                        message.error('Something went wrong, try again later.')
                    }
                    message.success('Task created.')
                } else {
                    message.error(taskData?.message || 'Could not create task.')
                }
                return
            }

            // updating
            const targetId = selectedTask?._id || createdTaskId
            if (!targetId) return
            const res = await dispatch(
                taskUpdate({ updateTask: payload, _id: targetId })
            )
            const data = res?.payload?.data
            if (data?.success) {
                // const byId = await dispatch(taskById({ _id: targetId }))
                // const bdata = byId?.payload?.data
                // if (bdata?.data?.[0]) dispatch(selectTaskUpdate(bdata.data[0]))
                // if (activeTab) {
                //     const sRes = await dispatch(getSprint({ id: activeTab }))
                //     const sData = sRes?.payload?.data
                //     if (sData?.success) dispatch(sprintSelect(sData.data))
                //     listTaskCall?.(sData?.data)
                // }
            } else {
                message.error(data?.message || 'Could not update task.')
            }
        } finally {
            setAutoSaving(false)
        }
    }

    /** simple debounce */
    function useDebouncedCallback(cb, delay = 800) {
        const t = useRef()
        return (...args) => {
            if (t.current) window.clearTimeout(t.current)
            t.current = window.setTimeout(() => cb(...args), delay)
        }
    }

    const debouncedAutoSave = useDebouncedCallback(
        (changedValues, allValues) => {
            createOrUpdate(allValues, Object.keys(changedValues))
        },
        800
    )

    const taskUpdateFilesCallback = async (url) => {
        const targetId = selectedTask?._id || createdTaskId
        if (!targetId) return
        dispatch(
            taskUpdate({
                updateTask: { attachment: [...taskFiles, url] },
                _id: targetId,
            })
        )
    }

    // useEffect(() => {
    //     if (taskFiles) {
    //         const allValues = form.getFieldsValue()
    //         debouncedAutoSave({ taskFiles }, allValues)
    //     }
    // }, [taskFiles])

    return (
        <>
            <DeletePopUp
                previewDelete={deleteModal}
                onDelete={() => {
                    setDeleteButtonLoading(true)
                    deleteTask()
                    setDeleteCheck(false)
                }}
                loadingButton={deleteButtonLoading}
                onCancel={() => {
                    setDeleteCheck(false)
                    setDeleteButtonLoading(false)
                    setDeleteModal(false)
                }}
                modalTitle="Delete Task"
                pageKey="Task"
            />
            <Drawer
                placement="right"
                width={drawerWidth}
                style={{
                    height: '100vh',
                }}
                styles={{
                    body: {
                        padding: '0px',
                        scrollbarColor: 'auto',
                        overflowX: 'hidden',
                    },
                    wrapper: {
                        scrollbarColor: 'auto',
                    },
                    content: {
                        scrollbarColor: 'auto',
                    },
                }}
                rootClassName="taskHeader"
                onClose={onCloseTaskDrawer}
                closeIcon={null}
                open={formModal}
                title={
                    <Row
                        justify="end"
                        style={{
                            columnGap: '15px',
                        }}
                        align="center"
                    >
                        {selectedTask && (
                            <Popover
                                content={dropDownContent(selectedTask?._id)}
                                trigger="click"
                                placement="bottom"
                                open={open}
                                styles={{
                                    body: {
                                        padding: '10px',
                                    },
                                }}
                                arrow={false}
                                onOpenChange={handleOpenChange}
                            >
                                <Icon
                                    icon="gravity-ui:ellipsis"
                                    height={20}
                                    width={20}
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                />
                            </Popover>
                        )}

                        {selectedTask && (
                            <CopyTextButton
                                text={`${window.location.origin}${window.location.pathname}?taskId=${selectedTask?._id}`}
                            />
                        )}
                        <Tooltip title="Close" placement="top">
                            <Icon
                                icon="ph:arrow-line-right"
                                onClick={onCloseTaskDrawer}
                                height={20}
                                width={20}
                                style={{
                                    cursor: 'pointer',
                                }}
                            />
                        </Tooltip>
                    </Row>
                }
            >
                <Spin spinning={taskStatus === 'loading' ? true : false}>
                    <Form
                        layout="vertical"
                        name="addTaskForm"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        form={form}
                        style={{
                            height: '100%',
                        }}
                        requiredMark={false}
                        initialValues={values}
                        onValuesChange={debouncedAutoSave} // ← auto-save on any change
                    >
                        <Flex gap={10}>
                            <Row
                                style={{
                                    overflow: 'auto',
                                    height: '100%',
                                }}
                            >
                                {(isEmpty(selectedTask) ||
                                    viewFieldCheck(
                                        'tasks',
                                        'title',
                                        userProfile
                                    )) && (
                                    <div
                                        style={{
                                            width: '100%',
                                            padding: '15px 25px 0px 8px',
                                        }}
                                    >
                                        <Form.Item
                                            name="title"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Enter Task Title',
                                                    whitespace: true,
                                                },
                                                {
                                                    max: 400,
                                                    message:
                                                        'Title should be maximum 400 characters long',
                                                },
                                            ]}
                                            colon={false}
                                        >
                                            <Input
                                                placeholder={
                                                    'Write a Task Title'
                                                }
                                                name={'title'}
                                                readOnly={
                                                    selectedTask &&
                                                    editFieldCheck(
                                                        'tasks',
                                                        'title',
                                                        userProfile
                                                    ) === false
                                                }
                                                variant="borderless"
                                                className={[
                                                    styles.taskSelect,
                                                    styles.taskTitleInput,
                                                ]}
                                                onChange={(event) => {
                                                    updateDetails(
                                                        event.target.name,
                                                        event.target.value
                                                    )
                                                }}
                                            />
                                        </Form.Item>
                                    </div>
                                )}
                                <div
                                    style={{
                                        minHeight: '100%',
                                    }}
                                >
                                    <Row
                                        style={{
                                            padding: '0px',
                                        }}
                                    >
                                        <Row
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            <Row
                                                style={{
                                                    width: '100%',
                                                    marginBottom: '5px',
                                                    padding:
                                                        '15px 25px 0px 25px',
                                                }}
                                            >
                                                <Col span={24}>
                                                    {(isEmpty(selectedTask) ||
                                                        viewFieldCheck(
                                                            'tasks',
                                                            'assigneeId',
                                                            userProfile
                                                        )) && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Assignee
                                                            </span>

                                                            <Form.Item
                                                                name="assigneeId"
                                                                colon={false}
                                                                style={{
                                                                    width: '80%',
                                                                }}
                                                            >
                                                                <AssigneeSelectPopover
                                                                    searchable
                                                                    assigneeList={
                                                                        assigneeList
                                                                    }
                                                                    selectedAssignee={
                                                                        assigneeList?.length >
                                                                        0
                                                                            ? assigneeList.find(
                                                                                  (
                                                                                      data
                                                                                  ) =>
                                                                                      data?.value ===
                                                                                      values?.assigneeId
                                                                              )
                                                                            : null
                                                                    }
                                                                    onChange={(
                                                                        val
                                                                    ) =>
                                                                        updateDetails(
                                                                            'assigneeId',
                                                                            val
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        selectedTask &&
                                                                        editFieldCheck(
                                                                            'tasks',
                                                                            'assigneeId',
                                                                            userProfile
                                                                        ) ===
                                                                            false
                                                                    }
                                                                    tooltipTitle="Select an assignee"
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                    {(isEmpty(selectedTask) ||
                                                        viewFieldCheck(
                                                            'tasks',
                                                            'epic',
                                                            userProfile
                                                        )) && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                // justifyContent:
                                                                //     'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Epic
                                                            </span>
                                                            <Form.Item
                                                                name="epic"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            'Please Select a Epic',
                                                                    },
                                                                ]}
                                                                colon={false}
                                                                style={{
                                                                    width: '30%',
                                                                }}
                                                            >
                                                                <TaskItemSelector
                                                                    options={
                                                                        epicsOption
                                                                    }
                                                                    placeholder="Select an Epic"
                                                                    value={form.getFieldValue(
                                                                        'epic'
                                                                    )}
                                                                    onChange={(
                                                                        val
                                                                    ) => {
                                                                        updateDetails(
                                                                            'epic',
                                                                            val
                                                                        )
                                                                    }}
                                                                    disabled={
                                                                        selectedTask &&
                                                                        editFieldCheck(
                                                                            'tasks',
                                                                            'epic',
                                                                            userProfile
                                                                        ) ===
                                                                            false
                                                                    }
                                                                    renderOption={(
                                                                        opt
                                                                    ) => (
                                                                        <div className="flex gap-2 capitalize">
                                                                            <Space>
                                                                                <Text>
                                                                                    {
                                                                                        opt?.epicKey
                                                                                    }
                                                                                </Text>
                                                                                <Text>
                                                                                    {
                                                                                        opt?.label
                                                                                    }
                                                                                </Text>
                                                                            </Space>
                                                                        </div>
                                                                    )}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}

                                                    {(isEmpty(selectedTask) ||
                                                        viewFieldCheck(
                                                            'tasks',
                                                            'type',
                                                            userProfile
                                                        )) && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                // justifyContent:
                                                                //     'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Type
                                                            </span>
                                                            <Form.Item
                                                                name="type"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            'Please Select a Task Type',
                                                                    },
                                                                ]}
                                                                colon={false}
                                                                style={{
                                                                    width: '30%',
                                                                }}
                                                            >
                                                                <TaskItemSelector
                                                                    placeholder="Select a Type"
                                                                    options={
                                                                        taskTypeOption
                                                                    }
                                                                    value={form.getFieldValue(
                                                                        'type'
                                                                    )}
                                                                    onChange={(
                                                                        val
                                                                    ) =>
                                                                        updateDetails(
                                                                            'type',
                                                                            val
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        (selectedTask &&
                                                                            editFieldCheck(
                                                                                'tasks',
                                                                                'type',
                                                                                userProfile
                                                                            ) ===
                                                                                false) ||
                                                                        activeTab
                                                                    }
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            marginBottom:
                                                                '10px',
                                                            alignItems:
                                                                'center',
                                                            justifyContent:
                                                                'space-between',
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                width: '20%',
                                                            }}
                                                        >
                                                            Fields
                                                        </span>
                                                        <div
                                                            style={{
                                                                border: '1px solid #ededed',
                                                                borderRadius: 8,
                                                                width: '80%',
                                                            }}
                                                        >
                                                            <Row
                                                                style={{
                                                                    borderBottom:
                                                                        '1px solid #ededed',
                                                                    padding:
                                                                        '8px 12px',
                                                                    alignItems:
                                                                        'center',
                                                                }}
                                                            >
                                                                <Col span={8}>
                                                                    <span
                                                                        style={{
                                                                            color: '#595959',
                                                                        }}
                                                                    >
                                                                        Priority
                                                                    </span>
                                                                </Col>
                                                                <Col span={16}>
                                                                    <Form.Item
                                                                        name="priority"
                                                                        style={{
                                                                            marginBottom: 0,
                                                                        }}
                                                                    >
                                                                        <PrioritySelector
                                                                            priorityType={
                                                                                priorityType
                                                                            }
                                                                            name="priority"
                                                                            updateDetails={(
                                                                                name,
                                                                                value
                                                                            ) =>
                                                                                updateDetails(
                                                                                    name,
                                                                                    value
                                                                                )
                                                                            }
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            {selectedTask && (
                                                                <Row
                                                                    style={{
                                                                        padding:
                                                                            '8px 12px',
                                                                        alignItems:
                                                                            'center',
                                                                    }}
                                                                >
                                                                    <Col
                                                                        span={8}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                color: '#595959',
                                                                            }}
                                                                        >
                                                                            Status
                                                                        </span>
                                                                    </Col>
                                                                    <Col
                                                                        span={
                                                                            16
                                                                        }
                                                                    >
                                                                        <Form.Item
                                                                            name="status"
                                                                            style={{
                                                                                marginBottom: 0,
                                                                            }}
                                                                        >
                                                                            <StatusSelector
                                                                                statusType={
                                                                                    swimLanesOption
                                                                                }
                                                                                name="status"
                                                                                updateDetails={(
                                                                                    name,
                                                                                    value
                                                                                ) =>
                                                                                    updateDetails(
                                                                                        name,
                                                                                        value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {(isEmpty(selectedTask) ||
                                                        viewFieldCheck(
                                                            'tasks',
                                                            'estimation',
                                                            userProfile
                                                        )) && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Estimation
                                                            </span>
                                                            <Form.Item
                                                                name="estimation"
                                                                colon={false}
                                                                rules={[
                                                                    {
                                                                        validator:
                                                                            async (
                                                                                _,
                                                                                names
                                                                            ) => {
                                                                                if (
                                                                                    !names
                                                                                ) {
                                                                                    return Promise.resolve()
                                                                                }
                                                                                const pattern =
                                                                                    ESTIMATION_PATTERN

                                                                                const patternNumber =
                                                                                    /^[0-9]$/

                                                                                if (
                                                                                    !pattern.test(
                                                                                        names
                                                                                    ) &&
                                                                                    !patternNumber.test(
                                                                                        names
                                                                                    )
                                                                                ) {
                                                                                    return Promise.reject(
                                                                                        new Error(
                                                                                            'Your estimate must be in the format 2w 4d 6h 45m.'
                                                                                        )
                                                                                    )
                                                                                }
                                                                            },
                                                                    },
                                                                ]}
                                                                style={{
                                                                    width: '80%',
                                                                }}
                                                            >
                                                                <Input
                                                                    placeholder={
                                                                        '2w 4d 6h 45m'
                                                                    }
                                                                    style={{
                                                                        border: 'none',

                                                                        borderRadius:
                                                                            '8px',
                                                                        color: '#000',
                                                                        fontWeight: 500,
                                                                    }}
                                                                    className={
                                                                        styles.taskTextInput
                                                                    }
                                                                    readOnly={
                                                                        selectedTask &&
                                                                        editFieldCheck(
                                                                            'tasks',
                                                                            'estimation',
                                                                            userProfile
                                                                        ) ===
                                                                            false
                                                                    }
                                                                    name={
                                                                        'estimation'
                                                                    }
                                                                    onBlurCapture={(
                                                                        event
                                                                    ) => {
                                                                        if (
                                                                            event
                                                                                .target
                                                                                .value
                                                                                ?.length >
                                                                            0
                                                                        )
                                                                            checkFinalEstimation(
                                                                                event.target.value.trimEnd()
                                                                            )
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                    {(isEmpty(selectedTask) ||
                                                        viewFieldCheck(
                                                            'tasks',
                                                            'sprintId',
                                                            userProfile
                                                        )) && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Sprint
                                                            </span>
                                                            <Form.Item
                                                                name="sprintId"
                                                                colon={false}
                                                                rules={[
                                                                    {
                                                                        required:
                                                                            values?.type !==
                                                                            'Bug',
                                                                        message:
                                                                            'Please Select a Sprint',
                                                                    },
                                                                ]}
                                                                style={{
                                                                    width: '80%',
                                                                }}
                                                            >
                                                                <TaskItemSelector
                                                                    options={
                                                                        sprintsOption
                                                                    }
                                                                    value={form.getFieldValue(
                                                                        'sprintId'
                                                                    )}
                                                                    onChange={(
                                                                        val
                                                                    ) => {
                                                                        updateDetails(
                                                                            'sprintId',
                                                                            val
                                                                        )
                                                                    }}
                                                                    required={
                                                                        values?.type !==
                                                                        'Bug'
                                                                    }
                                                                    disabled={
                                                                        (activeTab &&
                                                                            !selectedTask) ||
                                                                        editFieldCheck(
                                                                            'tasks',
                                                                            'sprintId',
                                                                            userProfile
                                                                        ) ===
                                                                            false ||
                                                                        isBugType
                                                                    }
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                    {(isEmpty(selectedTask) ||
                                                        viewFieldCheck(
                                                            'tasks',
                                                            'start',
                                                            userProfile
                                                        )) && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Date :
                                                            </span>
                                                            <Form.Item
                                                                colon={false}
                                                                name={
                                                                    'rangePicker'
                                                                }
                                                                className="rangePickerTask"
                                                                style={{
                                                                    width: '80%',
                                                                }}
                                                            >
                                                                <RangePicker
                                                                    picker={
                                                                        'date'
                                                                    }
                                                                    allowClear={
                                                                        false
                                                                    }
                                                                    readOnly={[
                                                                        true,
                                                                        false,
                                                                    ]}
                                                                    name={
                                                                        'rangePicker'
                                                                    }
                                                                    format={
                                                                        formatDatePicker
                                                                    }
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    bordered={
                                                                        false
                                                                    }
                                                                    disabled={
                                                                        selectedTask &&
                                                                        editFieldCheck(
                                                                            'tasks',
                                                                            'start',
                                                                            userProfile
                                                                        ) ===
                                                                            false
                                                                    }
                                                                    className={[
                                                                        styles.taskSelect,
                                                                    ]}
                                                                    onChange={(
                                                                        event
                                                                    ) => {
                                                                        if (
                                                                            form.getFieldValue(
                                                                                'start'
                                                                            ) !==
                                                                                undefined &&
                                                                            new Date(
                                                                                form.getFieldValue(
                                                                                    'start'
                                                                                )[
                                                                                    '$d'
                                                                                ]
                                                                            ).setHours(
                                                                                0,
                                                                                0,
                                                                                0,
                                                                                0
                                                                            ) !==
                                                                                new Date(
                                                                                    event[0][
                                                                                        '$d'
                                                                                    ]
                                                                                ).setHours(
                                                                                    0,
                                                                                    0,
                                                                                    0,
                                                                                    0
                                                                                ) &&
                                                                            selectedTask
                                                                        ) {
                                                                            setUpdatedValues(
                                                                                {
                                                                                    ...updatedValues,
                                                                                    start: new Date(
                                                                                        event[0][
                                                                                            '$d'
                                                                                        ]
                                                                                    ).setHours(
                                                                                        23,
                                                                                        59,
                                                                                        59,
                                                                                        999
                                                                                    ),
                                                                                }
                                                                            )
                                                                        }
                                                                        if (
                                                                            form.getFieldValue(
                                                                                'end'
                                                                            ) !==
                                                                                undefined &&
                                                                            new Date(
                                                                                form.getFieldValue(
                                                                                    'end'
                                                                                )[
                                                                                    '$d'
                                                                                ]
                                                                            ).setHours(
                                                                                23,
                                                                                59,
                                                                                59,
                                                                                999
                                                                            ) !==
                                                                                new Date(
                                                                                    event[1][
                                                                                        '$d'
                                                                                    ]
                                                                                ).setHours(
                                                                                    23,
                                                                                    59,
                                                                                    59,
                                                                                    999
                                                                                ) &&
                                                                            selectedTask
                                                                        ) {
                                                                            setUpdatedValues(
                                                                                {
                                                                                    ...updatedValues,
                                                                                    end: new Date(
                                                                                        event[1][
                                                                                            '$d'
                                                                                        ]
                                                                                    ).setHours(
                                                                                        23,
                                                                                        59,
                                                                                        59,
                                                                                        999
                                                                                    ),
                                                                                }
                                                                            )
                                                                        }
                                                                        setValues(
                                                                            {
                                                                                ...values,
                                                                                start: event[0],
                                                                                end: event[1],
                                                                            }
                                                                        )
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                </Col>
                                                <Col
                                                    span={24}
                                                    style={{
                                                        marginTop: '20px',
                                                    }}
                                                >
                                                    <span>Description</span>
                                                    <Form.Item
                                                        name="description"
                                                        colon={false}
                                                        style={{
                                                            marginTop: '5px',
                                                        }}
                                                    >
                                                        <TextArea
                                                            rows={6}
                                                            placeholder={
                                                                'What is this task about?'
                                                            }
                                                            readOnly={
                                                                selectedTask &&
                                                                editFieldCheck(
                                                                    'tasks',
                                                                    'description',
                                                                    userProfile
                                                                ) === false
                                                            }
                                                            className={
                                                                styles.taskTextArea
                                                            }
                                                            name={'description'}
                                                            onChange={(event) =>
                                                                updateDetails(
                                                                    event.target
                                                                        .name,
                                                                    event.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {selectedTask && (
                                                <Col
                                                    span={24}
                                                    style={{
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    <SubTaskSection
                                                        assigneeList={
                                                            assigneeList
                                                        }
                                                        epicsOption={
                                                            epicsOption
                                                        }
                                                        taskTypeOption={
                                                            taskTypeOption
                                                        }
                                                        sprintsOption={
                                                            sprintsOption
                                                        }
                                                        swimLanesOptionTask={
                                                            swimLanesOption
                                                        }
                                                    />
                                                </Col>
                                            )}
                                            <div
                                                style={{
                                                    padding: '15px 25px',
                                                }}
                                            >
                                                <AttachmentFileSection
                                                    taskUpdateFilesCallback={
                                                        taskUpdateFilesCallback
                                                    }
                                                />
                                            </div>
                                            {selectedTask && (
                                                <Row
                                                    style={{
                                                        width: '100%',
                                                        padding: '15px 25px',
                                                    }}
                                                >
                                                    <Col span={24}>
                                                        <Tabs
                                                            defaultActiveKey={
                                                                'sub-tasks'
                                                            }
                                                            onChange={(key) =>
                                                                setActiveTabComment(
                                                                    key
                                                                )
                                                            }
                                                            items={tabs}
                                                            className="generalTabs"
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </Row>
                                    </Row>
                                </div>
                            </Row>
                        </Flex>
                        {activeTabComment === 'comments' && (
                            <div
                                style={{
                                    borderTop: '1px solid #f0f0f0',
                                    padding: '16px 24px',
                                    background: '#fff',
                                    // textAlign: 'right',
                                    position: 'sticky',
                                    bottom: 0,
                                    zIndex: 10,
                                }}
                            >
                                <div
                                    style={{
                                        marginBottom: '10px',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                    }}
                                >
                                    {files?.length > 0 && (
                                        <>
                                            <Row gutter={[12, 12]}>
                                                {files.map((file, index) => {
                                                    const maxChars = 8
                                                    const displayName =
                                                        file?.name?.length >
                                                        maxChars
                                                            ? file?.name.slice(
                                                                  0,
                                                                  maxChars
                                                              ) + '…'
                                                            : file?.name

                                                    return (
                                                        <Col
                                                            key={index}
                                                            xs={24}
                                                            sm={12}
                                                            md={8}
                                                            lg={8}
                                                        >
                                                            <Card
                                                                size="small"
                                                                hoverable
                                                                style={{
                                                                    borderRadius: 12,
                                                                    background:
                                                                        '#fafafa',
                                                                    boxShadow:
                                                                        '0 2px 6px rgba(0,0,0,0.05)',
                                                                    padding:
                                                                        '5px 5px',
                                                                }}
                                                                // bodyStyle={{
                                                                //     display: "flex",
                                                                //     justifyContent: "space-between",
                                                                //     alignItems: "center",
                                                                // }}
                                                            >
                                                                <Space
                                                                    style={{
                                                                        marginRight:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    {getFileIcon(
                                                                        file?.name
                                                                    )}
                                                                    <Tooltip
                                                                        title={
                                                                            file?.name
                                                                        }
                                                                    >
                                                                        <Text>
                                                                            {
                                                                                displayName
                                                                            }
                                                                        </Text>
                                                                    </Tooltip>
                                                                </Space>

                                                                <Space>
                                                                    <DeleteOutlined
                                                                        style={{
                                                                            fontSize: 16,
                                                                            cursor: 'pointer',
                                                                            color: '#ff4d4f',
                                                                        }}
                                                                        onClick={() =>
                                                                            setFiles(
                                                                                (
                                                                                    prev
                                                                                ) =>
                                                                                    prev.filter(
                                                                                        (
                                                                                            _,
                                                                                            i
                                                                                        ) =>
                                                                                            i !==
                                                                                            index
                                                                                    )
                                                                            )
                                                                        }
                                                                    />
                                                                </Space>
                                                            </Card>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </>
                                    )}
                                </div>

                                {/* <Button
                                props={{
                                    text: selectedTask ? 'Save' : 'Create',
                                    htmlType: 'submit',
                                    loadingButton: taskLoadingButton,
                                    disabled:
                                        formValue?.title?.length === 0
                                            ? true
                                            : false,
                                    style: {
                                        height: '40px',
                                    },
                                }}
                            /> */}

                                <Row gutter={[10, 10]} align="top">
                                    {/* Editor takes most of the width */}
                                    <Col xs={24} sm={24} md={20} lg={22}>
                                        <MentionEditor
                                            member={filteredMembers}
                                            handleChangeMentions={
                                                handleChangeMentions
                                            }
                                            value={mentionData?.value}
                                            clearTrigger={clearEditor}
                                            loadingButton={addCommentLoader}
                                            onClickComment={() => s3Upload()}
                                            disabledButton={
                                                mentionData?.value?.length === 0
                                            }
                                        />
                                    </Col>

                                    {/* Attachment button */}
                                    <Col xs={24} sm={24} md={4} lg={2}>
                                        <AttachmentSection
                                            isText={true}
                                            getFileList={(files) => {
                                                setFiles(files)
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Form>
                </Spin>
            </Drawer>
        </>
    )
}

export default DrawerTaskForm
